class ShoppingCartNavigationObserver {
    private navItems: HTMLElement[];
    private activeClassname: string;
    private intersectionObserver: IntersectionObserver;
    private observedElements: Array<Element>;
    // @ts-ignore
    private callOnChangeCallback: (activeElement: HTMLElement) => void;

    constructor(navItems: NodeListOf<HTMLElement>, activeClassname: string) {
        this.navItems = Array.from(navItems);
        this.activeClassname = activeClassname;
        this.observedElements = [];

        this.intersectionObserver = new IntersectionObserver(this._observerCallback.bind(this), {
            rootMargin: '-25% 0px -75% 0px',
        });

        this.navItems.forEach((element) => {
            // @ts-ignore
            const contentArea = document.querySelector(element.getAttribute('href'));
            // @ts-ignore
            this.observedElements.push(contentArea);
            // @ts-ignore
            this.intersectionObserver.observe(contentArea);
        });
    }

    /**
     * @private
     */
    _observerCallback(entries: IntersectionObserverEntry[]) {
        const intersecting = entries.find((entry) => entry.isIntersecting);

        let activeAnchorLink = undefined;
        this.navItems.forEach((element) => {
            // @ts-ignore
            const anchorLink = element.parentElement.parentElement;
            // @ts-ignore
            anchorLink.classList.remove(this.activeClassname);
            if (intersecting && element.getAttribute('href') === `#${intersecting.target.id}`) {
                // @ts-ignore
                anchorLink.classList.add(this.activeClassname);
                activeAnchorLink = element;
            }
        });

        if (!activeAnchorLink) {
            const entry = entries[0];
            const lastElement = this.observedElements[this.observedElements.length - 1];

            // if we are after our last element, we want to highlight the last anchor link
            if (entry.target === lastElement && entry.boundingClientRect.top < 0) {
                const lastAnchorLink = this.navItems[this.navItems.length - 1];
                // @ts-ignore
                lastAnchorLink.parentElement.parentElement.classList.add(this.activeClassname);
                activeAnchorLink = lastAnchorLink;
            }

            if (activeAnchorLink === undefined) {
                const firstAnchorLink = this.navItems[0];
                // @ts-ignore
                firstAnchorLink.parentElement.parentElement.classList.add(this.activeClassname);
                activeAnchorLink = firstAnchorLink;
            }
        }

        if (this.callOnChangeCallback) {
            this.callOnChangeCallback(activeAnchorLink);
        }
    }

    setOnChangeCallback(cb: (activeElement: HTMLElement) => void) {
        this.callOnChangeCallback = cb;
    }
}

const navItems = document.querySelectorAll<HTMLAnchorElement>('.shoppingcart-detail .anchor-navigation .anchor-link a');
const observer = new ShoppingCartNavigationObserver(navItems, 'active');
observer.setOnChangeCallback((activeElement: HTMLElement) => {
    const orderSummary = document.querySelector<HTMLDivElement>('#widget_order_summary');

    // The orderSummary widget is only visible for logged-in users in the shopping cart
    if (!(orderSummary instanceof HTMLDivElement)) {
        return;
    }

    if (activeElement && activeElement.getAttribute('href') === '#cart_address') {
        orderSummary.classList.add('hidden');
    } else {
        orderSummary.classList.remove('hidden');
    }
});
